import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { TextField, TextFieldSkeleton } from 'components/shared/TextField/TextField';
import { FC, useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';

interface OwnProps {
  isinCode?: string;
}

export const IsinCode: FC<OwnProps> = ({ isinCode }) => {
  const { isLoading } = useContext(AddonMainFormContext);
  return (
    <BlockOrientationFormGroup inputId="isinCode" label="addon.isinCode">
      {(!isLoading || isinCode) && <TextField id="isinCode" value={isinCode} isReadOnly />}
      {isLoading && !isinCode && <TextFieldSkeleton />}
    </BlockOrientationFormGroup>
  );
};

IsinCode.displayName = 'IsinCode';
